import React from "react";

interface ErrorPopupProps {
  onClose?: () => void;
  message?: String;
}

const ErrorPopup: React.FC<ErrorPopupProps> = ({ onClose, message }) => {
  return (
    <>
      <div
        className="modal fade show d-block customkb-modal"
        tabIndex={-1}
        style={{ backgroundColor: "rgba(0, 0, 0, 0.5)" }}
        aria-labelledby="exampleModalLabel"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content" >
            <div className="modal-body" style={{margin: 0, display: 'flex', flexDirection: 'column', gap: '8px', justifyContent: 'center', alignItems: 'center'}}>
              <i className="bi bi-exclamation-circle-fill text-danger" style={{fontSize: '50px'}}></i>
              <p style={{margin: 0, textTransform: 'capitalize'}}>{message} </p>
            </div>
            <div className="modal-footer" style={{justifyContent: 'flex-end'}}>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={onClose}
              >
                Close
              </button>
            
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ErrorPopup;
